import React, { useEffect } from 'react';
import Popup from 'reactjs-popup';
import {DebounceInput} from 'react-debounce-input';
import PopupBtnClose from '../../../../../img/popup-close-button.svg';

function SearchBar(props) {

    return (
        <>
            <div className="filter--bar">
                <div className="flex-row flex-container sm-search-phrase-container">
                    <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7">
                        <label className="">Search</label>
                        <DebounceInput 
                            minLength={2}
                            debounceTimeout={800}
                            onChange={(e)=>{props.handleSearchPhraseChange(e.target.value)}} 
                            value={props.searchPhrase} 
                        />
                        <div className="sm-search-recommended-link-container">
                            Recommended search: 
                            { props.rec_phrases && Object.entries(props.rec_phrases).map(([index,rec_phrase]) => (
                                <a className="sm-search-recommended-link" onClick={(e) => props.handleRecommendedSearchClick(e, rec_phrase)}>{rec_phrase}</a>
                            ))}
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5">
                        <div class="search-checkbox-container">
                            <input type="checkbox" id="material-access-box" onChange={props.handleShowAccessibleMaterialsChange} checked={props.showAccessibleMaterials && "checked"} /> 
                            <label for="material-access-box"><span>Only show materials I can access</span></label>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <Popup
                    className="rct-popup"
                    trigger={<div className="sm-search-filters-link clear"><span className="">FILTERS</span> <img src="/wp-content/themes/kois-2017-web/img/icon-plus.svg" /></div>}
                    modal
                    nested
                    >
                    {close => (
                    <div className="modal">
                        <a className="rct-popup-content__close" onClick={close}><PopupBtnClose width="32" height="32" /></a>
                        <h1 className="alignleft">Filters</h1>
                        <div className="flex-row flex-container">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <label className="">Category</label>
                                <div className="selectbox-container">
                                    <select onChange={(e)=>{props.handleCategoryChange(e.target.value)}} value={props.selectedCategoryKey}>
                                        <option value="any">Any</option>
                                        { Object.entries(props.categories).map(([index,data]) => (
                                            <option key={data.id} value={data.id}>{data.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <label className="">Sub Category</label>
                                <div className="selectbox-container">
                                    <select onChange={(e)=>{props.handleSubCategoryChange(e.target.value)}} value={props.selectedSubCategoryKey}>
                                        <option value="any">Any</option>
                                        { props.selectedCategory && Object.entries(props.selectedCategory.subCategories).map(([index,data]) => (
                                            <option key={data.id} value={data.id}>{data.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            { props.selectedSubCategory && props.selectedSubCategory.children && props.selectedSubCategory.children.length > 0 &&
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <label className="">Topic</label>
                                    <div className="selectbox-container">
                                        <select onChange={(e)=>{props.handleThirdCategoryChange(e.target.value)}} value={props.selectedThirdCategoryKey}>
                                            <option value="any">Any</option>
                                            {Object.entries(props.selectedSubCategory.children).map(([index,data]) => (
                                                <option key={data.id} value={data.id}>{data.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            }
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <label className="">Related Course</label>
                                <div className="selectbox-container">
                                    <select onChange={(e)=>{props.handleRelatedCourseChange(e.target.value)}} value={props.selectedRelatedCourseKey}>
                                        <option value="any">Any Course</option>
                                        {Object.entries(props.relatedCourses).map(([index,data]) => (
                                            <option key={data.id} value={data.id}>{data.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <label className="">Language</label>
                                <div className="selectbox-container">
                                    <select onChange={(e)=>{props.setSelectedLanguage(e.target.value)}} value={props.selectedLanguage}>
                                        {Object.entries(props.languages).map(([index,data]) => (
                                            <option key={data.id} value={data.id}>{data.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                </Popup>
                { ( !props.loading && props.results.length > 0 && props.searchPhrase.length > 0) &&
                    <>
                        <h4 className="sm-search-result-summary">
                            {props.totalFound} Results found for: {props.searchPhrase}
                        </h4>
                    </>
                }
                { (props.selectedCategory !== null || props.selectedSubCategory !== null || props.selectedThirdCategory !== null || props.selectedRelatedCourse !== null || props.selectedLanguage !== props.englishId) &&
                    <>
                        <div className="sm-search-filter-pill-container">
                            <b>Filters applied:</b>&nbsp;
                            { props.selectedCategory !== null &&
                                <a className="sm-search-filters-pill" onClick={props.handleResetSelectedCategoryClick}>X {props.selectedCategory.label}</a>
                            }
                            { props.selectedSubCategory !== null &&
                                <a className="sm-search-filters-pill" onClick={props.handleResetSelectedSubCategoryClick}>X {props.selectedSubCategory.label}</a>
                            }
                            { props.selectedThirdCategory && props.selectedThirdCategory !== null &&
                                <a className="sm-search-filters-pill" onClick={props.handleResetSelectedThirdCategoryClick}>X {props.selectedThirdCategory.label}</a>
                            }
                            { props.selectedRelatedCourse !== null &&
                                <a className="sm-search-filters-pill" onClick={props.handleResetSelectedRelatedCourseClick}>X {props.selectedRelatedCourse.label}</a>
                            }
                            { props.selectedLanguage !== props.englishId &&
                                <a className="sm-search-filters-pill" onClick={() => props.setSelectedLanguage(props.englishId)}>X {props.selectedLanguageLabel}</a>
                            }
                            &nbsp;<a onClick={props.handleResetFiltersClick} className="connections-link">Clear All Filters</a>
                        </div>
                    </>
                }
            </div>
        </>
    );
}

export default SearchBar;